export default __webpack_public_path__ + "static/1559-68cc98218842e46e13c4cb691fe612e8.gif";